import React from 'react';
import { useState, useEffect } from 'react';


import './event.css'
import './home.css'
import './../animations.css'

import Header from '../components/layout/header';
import HeadingBlock from '../components/common/heading';
import back from './../assets/back.svg'
import { supabase } from '../supabase';
import ExhibitionDetails from '../sections/eventDetails';
import CountdownTimer from '../sections/countdown';
import ExhibitionMap from '../sections/ExhibitionMap';
import Button from '../components/common/button';
import { Link } from 'react-router-dom';
const Event = () => {
  useEffect(() => {
    const originalColor = window.getComputedStyle(document.body).backgroundColor;
    document.body.style.setProperty('background-color', '#FFF4E2', 'important');

    return () => {
      document.body.style.removeProperty('background-color');
      document.body.style.backgroundColor = originalColor;
    };
  }, []);

  return ( <>
  <header className='header3'>
   <button>
    <Link to="/home">
    <img src={back} alt="" />
    </Link>
   </button>
     <HeadingBlock 
        style1="dark left"
        heading="Exhibition Details"
        />
  </header>
       <main className='fixedWidth'>
    <div className="secContainer modelCont cardsSec fixedWidth">
        <ExhibitionDetails />
        <Button cta="Book Now"
        link="/booking"
        style1="size1 blue"
        />
    </div>
    
    <section className='secContainer cardsSec fixedWidth'>
      <HeadingBlock 
        style1="dark left"
        heading="Time Until Exhibition Ends"
        />
        <CountdownTimer />
    </section>
       
   <div className="secContainer sec2Cont  modelCont mapCont fixedWidth">
    <section className='section2 mapSec'>
  
    <div className="map1 map2">
        <HeadingBlock 
        style1="light left"
        heading="Exhbition Map"
        subheading="View our booths and find directions in 3D mode"
        />
<ExhibitionMap />    
    </div>
    </section>
   </div>
 
    </main>
    </> );
}
 
export default Event;